import React from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';

const DateRangeSelector = ({ 
  startDate, 
  endDate, 
  onDateChange 
}) => {
  // Format date to YYYY-MM-DD for input fields
  const formatDateForInput = (date) => {
    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
  };

  // Handle date input changes
  const handleStartDateChange = (e) => {
    const newStartDate = new Date(e.target.value);
    onDateChange({
      selection: {
        startDate: newStartDate,
        endDate: endDate,
        key: 'selection'
      }
    });
  };

  const handleEndDateChange = (e) => {
    const newEndDate = new Date(e.target.value);
    onDateChange({
      selection: {
        startDate: startDate,
        endDate: newEndDate,
        key: 'selection'
      }
    });
  };

  // Handle shortcut buttons
  const moveEarlier = () => {
    const newStartDate = new Date(startDate);
    newStartDate.setDate(newStartDate.getDate() - 14);
    
    onDateChange({
      selection: {
        startDate: newStartDate,
        endDate: endDate,
        key: 'selection'
      }
    });
  };

  const moveLater = () => {
    const newEndDate = new Date(endDate);
    newEndDate.setDate(newEndDate.getDate() + 14);
    
    onDateChange({
      selection: {
        startDate: startDate,
        endDate: newEndDate,
        key: 'selection'
      }
    });
  };

  const resetDates = () => {
    const now = new Date();
    const newStartDate = new Date(now);
    newStartDate.setDate(now.getDate() - 14);
    
    const newEndDate = new Date(now);
    newEndDate.setDate(now.getDate() + 14);
    
    onDateChange({
      selection: {
        startDate: newStartDate,
        endDate: newEndDate,
        key: 'selection'
      }
    });
  };

  return (
    <div className="date-range-selector d-flex align-items-center">
      <Button variant="outline-secondary" onClick={moveEarlier} className="me-1">
        &lt;&lt;
      </Button>
      <Form.Control
        type="date"
        value={formatDateForInput(startDate)}
        onChange={handleStartDateChange}
        style={{ width: '130px' }}
      />
      <span className="mx-1">-</span>
      <Form.Control
        type="date"
        value={formatDateForInput(endDate)}
        onChange={handleEndDateChange}
        style={{ width: '130px' }}
      />
      <Button variant="outline-secondary" onClick={moveLater} className="mx-1">
        &gt;&gt;
      </Button>
      <Button variant="outline-secondary" onClick={resetDates} title="Reset dates" className="px-2">
        ✕
      </Button>
    </div>
  );
};

export default DateRangeSelector;
